/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorReviewsAssignedConversationDetailsRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'standalone.monitor.reviews.assigned.conversation.details',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorReviewsAssignedConversationDetailsRoute);
